import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const ExclusiveBlockSwiper = () => {
  const [slidesPerView, setSlidesPerView] = useState(3.3);
  const [spaceBetween, setSpaceBetween] = useState(35);

  useEffect(() => {
    const updateSwiperSettings = () => {
      if (window.innerWidth <= 768) {
        setSlidesPerView(1.3);
        setSpaceBetween(20); // Reduce space between slides for mobile
      } else {
        setSlidesPerView(3.3);
        setSpaceBetween(35); // Keep desktop spacing the same
      }
    };

    updateSwiperSettings();
    window.addEventListener("resize", updateSwiperSettings);
    return () => window.removeEventListener("resize", updateSwiperSettings);
  }, []);

  const slidesData = [
    {
      img: "/assets/travel.svg",
      title: "Discounted Travel Insurance",
      description:
        "Enjoy discounted travel insurance when you use your Nimo Forex Card, giving you peace of mind wherever you go.",
    },
    {
      img: "/assets/Simcard.svg",
      title: "Free International Sim Card",
      description:
        "Stay connected abroad with a free international SIM card for hassle-free communication during your travels.",
    },
    {
      img: "/assets/ZeroAtm.svg",
      title: "Zero ATM Fees Withdrawals",
      description:
        "Access cash without additional charges at ATMs globally, keeping your travel expenses low. ",
    },
    {
      img: "/assets/DiscountTravel.svg",
      title: "Special Deals and Offers",
      description:
        "Get exclusive discounts on hotel bookings, flights, and more through our partnerships with leading travel providers.",
    },
    {
      img: "/assets/GlobalAccessIcon.svg",
      title: "Global Access to Exclusive Lounges",
      description:
        "Access premium airport lounges worldwide with your Nimo Forex Card for a more comfortable travel experience. ",
    },
    {
      img: "/assets/ComplimentaryIcon.svg",
      title: "Complimentary Global Wi-Fi ",
      description:
        "Stay online with complimentary global Wi-Fi at select airports, coffee shops, and hotels, available exclusively to Nimo cardholders. ",
    },
    {
      img: "/assets/PersonalisedTravelIcon.svg",
      title: "Personalised Travel Recommendations ",
      description:
        "Receive tailored travel tips, guides, and discounts based on your spending and destinations, making your journey even smoother.",
    },
  ];

  return (
    <div className="relative mb-4 md:mb-[5rem] mt-12 md:mt-28">
      {/* Custom Navigation Buttons */}
      <button className="custom-prev group absolute left-0 top-[-16%] transform -translate-y-1/2 z-10 hidden md:block bg-[#F4F4F4] hover:bg-[#E11740] w-[3.25rem] h-[3.35rem] rounded-full flex items-center justify-center transition-all duration-300">
        <img
          src="/assets/prevButton.svg"
          alt="Previous"
          className="w-6 h-6 brightness-0 invert-0 transition-all duration-300 group-hover:brightness-0 group-hover:invert ml-[25%]"
        />
      </button>

      <button className="custom-next group absolute left-[5%] min-[1024px]:left-[8%] top-[-16%] transform -translate-y-1/2 z-10 hidden md:block bg-[#F4F4F4] hover:bg-[#E11740] w-[3.25rem] h-[3.25rem] rounded-full flex items-center justify-center transition-all duration-300">
        <img
          src="/assets/nextButton.svg"
          alt="Next"
          className="w-6 h-6 brightness-0 invert-0 transition-all duration-300 group-hover:brightness-0 group-hover:invert ml-[25%]"
        />
      </button>

      <Swiper
        modules={[Navigation]}
        spaceBetween={spaceBetween}
        slidesPerView={slidesPerView}
        slidesPerGroup={1} // Moves exactly one slide per click
        navigation={{ nextEl: ".custom-next", prevEl: ".custom-prev" }} // Custom navigation
        loop={true} // Enables infinite loop
        className="w-full"
      >
        {slidesData.map((slide, index) => (
          <SwiperSlide key={index}>
            <div className="bg-white border h-[19rem] md:h-[25rem] px-[1.89rem] pt-8 md:px-10 md:py-11 md:pb-6 rounded-t-2xl shadow-[0px_-25px_22.3px_-14px_rgba(113,113,113,0.10)]">
              <img src={slide.img} alt={slide.title} />
              <h2 className="text-[#232323] w-[80%] md:w-full font-[Figtree] text-[1.10906rem] md:text-[1.5rem] font-extrabold leading-[1.47881rem] md:leading-8 tracking-[-0.03rem] md:pr-24 min-[1024px]:pr-0 my-4 md:my-7">
                {slide.title}
              </h2>
              <p className="text-[#252525] font-[Figtree] text-[0.73938rem] md:text-[1rem] font-medium leading-[1.15531rem] md:leading-[1.5625rem] tracking-[0.04rem]">
                {slide.description}
              </p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default ExclusiveBlockSwiper;
